import * as React from 'react';
import svgSrc from 'assets/product-week.svg';

export const ProductWeek = props => (
  <figure {...props}>
    <img src={svgSrc} alt="Product of the week" />
  </figure>
);
